/**
 * Stable date stamp for AI-render UserItem names (`2026-09-03`).
 * Uses sv-SE so the result is ISO-like and independent of the browser locale.
 */
export function formatFloorplanRenderDateStamp(date: Date = new Date()): string {
  return new Intl.DateTimeFormat("sv-SE").format(date);
}

/**
 * Default Uploads name for a floorplan AI render: project name + date stamp.
 * The render modal auto-fills this and lets the user edit it before generating.
 */
export function buildFloorplanRenderUserItemName(
  projectName?: string | null,
  date: Date = new Date(),
): string {
  const base = projectName?.trim() || "Untitled";
  return `${base} – ${formatFloorplanRenderDateStamp(date)}`;
}
